module.exports = __webpack_public_path__ + "img/fyt_p10.9fb775e6.png";